// extracted by mini-css-extract-plugin
export default {"wrapper":"Faq_wrapper__oj4jU","customeHeader":"Faq_customeHeader__3L1ye"};